import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class ConsentPage extends Component {
  render() {
    return (
        <div className='page consent'>
          <h1>
            <FormattedMessage id='app.consent.header' defaultMessage='Consent' />
          </h1>

          [informed consent here]
        </div>
    );
  }
}

export default ConsentPage;



// WEBPACK FOOTER //
// ./src/pages/ConsentPage.js